import { render, staticRenderFns } from "./FormulacionDetallePage.vue?vue&type=template&id=3fefcd2f"
import script from "./FormulacionDetallePage.js?vue&type=script&lang=js&external"
export * from "./FormulacionDetallePage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports